module.exports = __webpack_public_path__ + "img/wide.88e0dbc9.jpg";